import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { Link } from '@printdeal/ui-library';
import { dispatchDataLayerClickTrackAndTrace } from '../../../../../helpers/dataLayerHelpers/OrderDetailDataLayerHelper';

interface Props {
  trackingLink: string
}

const DeliveriesLink = ({ trackingLink }: Props) => (
  <Link
    as={GatsbyLink}
    to={trackingLink}
    rel="noopener noreferrer"
    target="_blank"
    className="pd-text-xs"
    onClick={() => dispatchDataLayerClickTrackAndTrace()}
    iconBefore="truck"
    variant="secondary"
  >
    <FormattedMessage
      id="account.order.orderline.trackAndTrace"
      defaultMessage="Track & Trace"
    />
  </Link>
);

export default DeliveriesLink;
